import React, { Component } from "react";
import { connect } from "react-redux";
import CustomSelect from "../../components/common/select/Select";
import TTSLineChart from "../../components/line-charts/TTSLineChart";
import PratDashboardMiddleware from "../../store/prat_middleware/pratDashboard/pratDashboardMiddleware";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import CustomToast from '../../util-functions/customToast.jsx'

class TTS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: [],
      data: [],
      filePopUp: false
    };
  }

  componentDidMount() {
    let arr = [];
    if(this.props.categories){
      this.props.categories.forEach(item => {
        arr.push(item.guid);
      });
      this.setState(
        {
          selectedCategory: arr
        },
        () => {
          this.handleSubmit();
        }
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.categories !== this.props.categories) {
      let arr = []
      this.props.categories.forEach(item => {
        arr.push(item.guid)
      })
      this.setState({
        selectedCategory: arr
      }, () => {
        this.handleSubmit();
      })
    }
  }

  handleCategory = category => {
    let arr = [];
    if (category === null || category.length === 0) {
      this.setState(
        {
          selectedCategory: []
        },
        () => {
          this.handleSubmit();
        }
      );
    } else {
      category.forEach(element => {
        arr.push(element.value);
      });
      this.setState({ selectedCategory: arr }, () => {
        this.handleSubmit();
      });
    }
  };

  handleSubmit = () => {
    this.props.getTTSChart(this.state.selectedCategory);
  };

  handleTtsXlsxDownload = () => {
    if (this.state.selectedCategory.length) {
      this.props.downloadTtsXlsx(this.state.selectedCategory)
    } else {
      CustomToast('error', 'Category not selected!')
    }
  }

  render() {
    return (
      <div className="tts-container">
        <div className="tts-heading-cta">
          <span className="tts-heading">TTS 2016-2020</span>

          <CustomSelect.MyCustomSelect
            className='filter-font-size'
            placeholder={"Category"}
            allowSelectAll={true}
            isMulti
            options={
              this.props.categories
                ? !this.props.categories
                  ? void 0
                  : this.props.categories.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            onChange={this.handleCategory}
            value={
              this.props.categories
                ? this.props.categories
                  .filter(item => {
                    return !this.state.selectedCategory
                      ? void 0
                      : this.state.selectedCategory.includes(item.guid);
                  })
                  .map(item => {
                    return {
                      value: item.guid,
                      label: item.Name
                    };
                  })
                : void 0
            }
          />

          <div className="tts-cta-container">
            <img
              className="images-style"
              src={require("../../assets/images/refreshArrows.svg")}
              onClick={this.handleSubmit}
              alt=''
            />
            <div className="funnel-filter-container">
              <div style={{ display: 'flex', cursor: 'pointer' }}
                onClick={() => {
                  this.setState({ filePopUp: !this.state.filePopUp });
                }}
              >
                <img
                  className="image-transform"
                  src={require("../gt/images/dots.png")}
                  alt=''
                />
              </div>

              {this.state.filePopUp ? (
                <ClickAwayListener
                  onClickAway={() => {
                    this.setState({ filePopUp: false });
                  }}
                >
                  <div
                    className="funnel-pop-up"
                    style={{ width: "140px", height: 'auto', flexDirection:'column' }}
                  >
                    {/* <span className="division-cta">
                      <input type='checkbox' value={this.state.isDivision} onChange={() => this.setState({ isDivision: !this.state.isDivision })} />
                      <label>Division</label>
                    </span> */}
                    <button className='xlsx-download-cta' onClick={this.handleTtsXlsxDownload}>Download Excel</button>
                  </div>
                </ClickAwayListener>
              ) : null}
            </div>
          </div>
        </div>

        {this.props.isTTSChartLoading ? (
          <div style={{ marginTop: "100px" }}>
            <img
              src={require("../../assets/images/barsLoader.svg")}
              style={{ width: "60px", height: "60px" }}
              alt=''
            />
          </div>
        ) : (
            <TTSLineChart data={this.props?.TTSChart} />
          )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    TTSChart: state.PratDashboardReducer.TTSChart,
    isTTSChartLoading: state.PratDashboardReducer.isTTSChartLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getTTSChart: selectedCategory => {
      return dispatch(PratDashboardMiddleware.getTTSChart(selectedCategory));
    },
    downloadTtsXlsx: (selectedCategory) => {
      return dispatch(
        PratDashboardMiddleware.downloadTtsXlsx(
          selectedCategory,
        )
      );
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TTS);
